// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__JayrV","logo":"Sidebar_logo__-yfVS","menu":"Sidebar_menu__p9uXe","menu-item":"Sidebar_menu-item__3Sr4J","active":"Sidebar_active__LyIwh"};